import React from "react";

import { FlexLayout, FlexLayoutProps } from "../FlexLayout/FlexLayout";

type HStackProps = FlexLayoutProps;

/**
 * @purpose Horizontal layout primitive — lays children out left-to-right with
 * a tokenized gap, so spacing lives on the container instead of child margins.
 *
 * @example
 * <HStack gap={8} align="center" justify="between">
 *     <Title />
 *     <Actions />
 * </HStack>
 */
export const HStack = (props: Readonly<HStackProps>) => (
    <FlexLayout direction="row" {...props} />
);
